import { ProtectedImg } from "../../utils/protectedFile";
import { useMyOrganizations } from "../../utils/useMyOrganizations";
import { formatDateTime } from '../../utils/dateFormat';
const moment = require('moment-timezone');

const QUOTES = [
  "Small steps every day add up to big results.",
  "Quality care starts with attention to detail.",
  "Progress, not perfection.",
  "Every patient you help is a life you touch.",
  "Consistency turns the ordinary into the exceptional.",
  "Do the little things well and the big things follow.",
  "Compassion is the best medicine.",
  "Excellence is a habit, not an act."
];
const quoteOfTheDay = () => { const d = new Date(); return QUOTES[(d.getFullYear()*372 + d.getMonth()*31 + d.getDate()) % QUOTES.length]; };

// Props: name, profileImg, subtitle, createdAt, onUpload(file) -> Promise, children (extra content, e.g. action buttons)
const WelcomeBanner = ({ name, profileImg, subtitle, createdAt, onUpload, children }) => {
  const { label: organizationLabel } = useMyOrganizations();
  return (
  <div className="container-fluid">
    <div className="welcomeBack-background" style={{ backgroundColor: '#004AAD' }}>
      <div className="row-display">
        <div className="col-md-8">
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ position: 'relative', width: '80px', height: '80px', flex: '0 0 auto' }}>
              <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: 'rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '34px' }}><i className="bx bx-user"></i></div>
              {profileImg ? <ProtectedImg fileName={profileImg} alt="" onError={(e) => { e.target.style.display = 'none'; }} style={{ position: 'absolute', inset: 0, width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #fff' }} /> : null}
              {onUpload ? (
                <label style={{ position: 'absolute', bottom: 0, right: 0, width: '26px', height: '26px', background: '#0018F9', color: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: '2px solid #fff' }} title="Change photo">
                  <i className="bx bx-camera" style={{ fontSize: '15px' }}></i>
                  <input type="file" accept="image/*" style={{ display: 'none' }} onChange={async (e) => { const f = e.target.files && e.target.files[0]; if (!f) return; try { await onUpload(f); window.location.reload(); } catch (err) { window.alert('Photo upload failed — please try again.'); } }} />
                </label>
              ) : null}
            </div>
            <h3 className="welcomeBack-heading" style={{ color: '#ffffff', margin: 0 }}>Logged In: {name || ''}</h3>
          </div>
          {subtitle ? <p className="m-0 p-0 mt-2" style={{ color: '#ffffff' }}><b>{subtitle}</b></p> : null}
          <p className="m-0 p-0" style={{ color: '#ffffff' }}>Today is : {formatDateTime(new Date())}</p>
          <hr style={{ borderColor: 'rgba(255,255,255,0.5)' }} />
          <p style={{ color: '#ffffff', fontStyle: 'italic', margin: 0 }}>{quoteOfTheDay()}</p>
          {children}
        </div>
        <div className="col-md-4">
          <div>
            <h4 className="welcomeBack-heading" style={{ color: '#ffffff' }}>Organization:</h4>
            <p style={{ color: '#ffffff' }}><b>{organizationLabel}</b></p>
            {createdAt ? <>
              <p className="p-0 m-0" style={{ color: '#ffffff' }}><b>Account Created Date.</b></p>
              <p style={{ color: 'rgba(255,255,255,0.75)' }}>{formatDateTime(createdAt)}</p>
            </> : null}
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default WelcomeBanner;
